export default __webpack_public_path__ + "src/assets/tasks/wordchaos/Ordkaos_avslutning.mp3";